import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import InvoiceNcfComponent from './invoice-ncf.component';

let InvoiceNcfModule = angular
  .module('InvoiceNcf', [
    uiRouter
  ])
  .component('invoiceNcf', InvoiceNcfComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('invoiceNcf', {
      url: '/invoice-ncf',
      data: {
        authRequired: true,
        permsRequired: ['view-ncf', 'create-ncf']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'invoiceNcf'
        }
      },
      resolve: {
        ncfObservable: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-ncf') ? ContentService.getNcfList() : {};
        }
      }
    })
  })
  .name;

export default InvoiceNcfModule;



// WEBPACK FOOTER //
// ./src/app/pages/invoice-ncf/invoice-ncf.module.js